import React from 'react';

import ReactHtmlParser from 'react-html-parser';
import { CmsCardContainerProps } from '@types';
import { CmsContent } from './CmsCardContainer.styled';

/**
 * @param id - unique identifier for the widget
 * @param content - content received from the CMS
 * @returns - parsed content of CMS
 */
const CmsCardContainer: React.FC<CmsCardContainerProps> = ({ id, content }) => {
    return (
        <CmsContent data-testid="CmsCardContainer" id={id}>
            {ReactHtmlParser(content)}
        </CmsContent>
    );
};

export default React.memo(CmsCardContainer);
